import {useQuery} from "react-query";
import {apiV2} from "@/api/axiosConfig";
import {isValidObjectID} from "@/lib/misc/isValidObjectID";

type NotificationGroup = {
    id: string;
    name: string;
};

export const fetchNotificationGroup = (id: string) =>
    apiV2.get<NotificationGroup>(`/notification-groups/${id}`).then(res => res.data);

export const useLoadNotificationGroup = (id: string | null) =>
    useQuery(["notification-group", id], () => fetchNotificationGroup(id!), {
        enabled: isValidObjectID(id),
        staleTime: 5 * 60 * 1000,
    });
